<script>
import { copy } from '@/utils/tools'
export default {
    name: 'AssignmentDialog',
    props: {
        value: {
            type: Boolean,
            default: false
        },
        bizFieldList: {
            type: Array,
            default: () => []
        },
        formList: {
            type: Array,
            default: () => []
        },
        bizAssignmentRules: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            dialogVisible: false,
            assignmentRules: []
        }
    },
    watch: {
        value(v) {
            this.dialogVisible = v
        },
        bizAssignmentRules(v) {
            if(Array.isArray(v) && v.length) {
                this.assignmentRules = copy(v)
            }
        }
    },
    render() {
        const addItem = () => {
            this.assignmentRules.push({bizFieldCode: '', currentFieldCode: ''})
        }
        const handelConfirm = () => {
            this.$emit('confirm', this.assignmentRules)
            this.$emit('input', false)
        }
        return (
            <el-dialog 
                title="赋值规则" 
                width="60%" 
                visible={this.value}
                beforeClose={() => this.$emit('input', false) }
                close-on-click-modal         
            >
                {
                    this.assignmentRules.length ? <el-alert title="尽量使用同一类型的组件赋值，例如：单行文本 赋值到 单行文本" type="warning" closable={false}></el-alert> : undefined
                } 
                {
                    this.assignmentRules.map((item, index) => {
                        return (
                            <el-row key={index} style="margin: 10px 0">
                                <el-col span={8}>
                                    <el-select placeholder="请选择业务字段" v-model={item.bizFieldCode} size="small">
                                        {
                                            this.bizFieldList.map((item, index) => {
                                                return (
                                                    <el-option key={index} label={item.name} value={item.code} />
                                                )
                                            })
                                        }
                                    </el-select>
                                </el-col>
                                <el-col span={2} style="line-height: 32px">赋值到</el-col>
                                <el-col span={8}>
                                    <el-select placeholder="请选择表单字段" v-model={item.currentFieldCode} size="small">
                                        {
                                            this.formList.map((item, index) => {
                                                return (
                                                    <el-option key={index} label={item.name} value={item.code} />
                                                )
                                            })
                                        }
                                    </el-select>
                                </el-col>
                                <el-col span={2}>
                                    <i class="el-icon-delete"
                                        onClick={() =>  this.assignmentRules.splice(index, 1)}
                                        style="font-size: 15px; line-height: 32px; margin-left: -25px; cursor: pointer"
                                    />
                                    </el-col>
                            </el-row>
                        )
                    })
                }
                <el-button onClick={addItem} icon="el-icon-circle-plus-outline" type="text">添加赋值规则</el-button>
                <template slot="footer">
                    <span>
                        <el-button onClick={() => this.$emit('input', false) }>取 消</el-button>
                        <el-button type="primary" onClick={() => handelConfirm() }>确 定</el-button>
                    </span>
                </template>
            </el-dialog>
        )
    }
}
</script>